import { supabase } from "@/integrations/supabase/client";
supabase.realtime.removeAllChannels();

import { act } from "react";

const cache: Record<string, any[]> = {}; // runtime memory cache
const channels: Record<string, any> = {}; // store Supabase channels to avoid multiple subscriptions
type Filter = {
  column: string;
  operator: "eq" | "neq" | "gt" | "lt" | "like" | "ilike" | "in";
  value: any;
};

export async function fetchData(
  table: string,
  columns: string = "*",
  orderby: string = "srno",
  activecolumn: string = "is_active",
  active:boolean=true,
  forceRefresh = false,  
  onUpdate?: (data: any[]) => void, // callback for Realtime updates
  filters: Filter[] = [] 
) {
  // 1️⃣ Runtime cache
  if (cache[table] && !forceRefresh) {
    //console.log("📦 Returning from runtime cache:", table);
    return cache[table];
  }
 
  let query = (supabase as any).from(table).select(columns);
  query = query.eq(activecolumn, active);
  filters.forEach((f) => {
    query = (query as any)[f.operator](f.column, f.value);
  });
  query = query.order(orderby, { ascending: true });  
  const { data, error } = await query;
  if (error) {
    //console.error(`❌ Supabase fetch error [${table}]:`, error.message);
    return [];
  }

  // 5️⃣ Setup Realtime subscription (once per table)
  if (typeof window !== "undefined" && !channels[table]) {
    const channel = supabase
      .channel(`${table}-updates`)
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table },
        (payload) => {
         // console.log("🔔 Realtime change detected:", payload);

          // Fetch updated data using .then() (no async inside .on)
          (supabase as any)
            .from(table)
            .select(columns)
            .eq(activecolumn, active)
            .order(orderby, { ascending: true })
            .then(({ data: newData, error }) => {
              if (!error && newData) {                
                if (onUpdate) onUpdate(newData);
              }
            });
        }
      )
      .subscribe();

    channels[table] = channel;
  }
  return data;
}
